<template>
  <div id="footer_content" class="footer_content">
    <h1 class="b_more">VIEW ALL NEWS</h1>
    <div class="swiper-container" id="swiper_container_three">
      <ul class="swiper-wrapper fc_news">
        <li v-for="(item, index) in footerDatas" :key="index" class="swiper-slide">
          <a href="javascript: void(0);" class="news_item_link">
            <img :src="item.thumb_guid" alt="" />
            <div class="new_text_wrapper">
              <div class="news_text">
                <h3>NEWS</h3>
                <h5><span>{{item.thumb_title}}</span><span class="title_en">{{item.thumb_title_en}}</span></h5>
                <p class="paragraph">{{item.thumb_content}}</p>
              </div>
              <div class="b_block"></div>
            </div>
          </a>
        </li>
      </ul>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
    </div>

    <ul class="list_container">
      <li><a href="/xy_web/" class="logo"><img src="../assets/logo_black.png" alt="" /></a></li>
      <li>
        <ul class="fb">
          <li><span class="fp_bl">freshcoo@126.com</span></li>
          <li><span class="fp_bl">729147024@qq.com</span></li>
          <li><span class="fp_bl">0755-82560967</span></li>
        </ul>
      </li>
      <li>
        <p><span class="fp_bl fp_title">Shenzhen</span></p>
        <p>
          <span>深圳市福田保税区广兰道6号深装总大厦A座650</span>
          <span>616 Block A, SDCIC mansion, 6, Guanglan Road, Bonded area, Futian, Shenzhen</span></p>
      </li>
      <li>
        <p><span class="fp_bl fp_title">Beijing</span></p>
        <p>
          <span>北京市东城区东四十条94号亮点设计中心B座一层112-113</span>
          <span>112-113, 1st floor, Block B, 94, Dongsishi, Dongcheng District, Beijing</span></p>
      </li>
    </ul>
  </div>
</template>

<script>
  import axios from "axios";
  import Swiper from "./common/swiper/index.js";
  export default {
    name: "FooterThree",
    data: function() {
      return {
        footerDatas: []
      }
    },
    components: { Swiper },
    mounted: function(){
      axios.get("/xy_api/home.php?page=home").then(res => {
        if(res.status == 200) {
          this.footerDatas = res.data.homeBottomDatas;
          this.$nextTick(() => {
            let SwiperFt = Swiper.Swiper;
            var swiper = new SwiperFt('#swiper_container_three', {
              slidesPerView: 3,
              spaceBetween: 0,
              slidesPerGroup: 3,
              loop: true,
              loopFillGroupWithBlank: true,
              /* autoplay: true, */
              navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
              },
            });
          });
        }
      }).catch(err => {
        console.log(err);
      });
    }
  }
</script>

<style type="text/less" lang="less" scoped="scoped">
  .footer_content {
    .swiper-container {
      width: 100%;
      max-height: 100vh;
      .fc_news {
        li {
          width: 33.333%;
          /* height: 17.647vw; */
          height: 19.479vw;
          .new_text_wrapper {
            .news_text {
              h3 {
                font-size: 1.558em;
                letter-spacing: normal;
              }
              h5 {
                font-size: 2.125em;
                span {
                  display: block;
                }
                .title_en {
                  font-size: 0.533em;
                  letter-spacing: normal;
                }
              }
            }
          }
        }
      }
      .swiper-wrapper {
        width: 100%;
        padding: 0;
        margin: 0;
        .swiper-slide {
          font-size: 18px;
          background: #fff;

          /* Center slide text vertically */
          display: -webkit-box;
          display: -ms-flexbox;
          display: -webkit-flex;
          display: flex;
          -webkit-box-pack: center;
          -ms-flex-pack: center;
          -webkit-justify-content: center;
          justify-content: center;
          -webkit-box-align: center;
          -ms-flex-align: center;
          -webkit-align-items: center;
          align-items: center;
          img {
            display: block;
            width: 100%;
          }
        }
      }
      .swiper-button-prev,
      .swiper-button-next {
        color: white;
      }
      .swiper-pagination-bullet {
        opacity: 0.5;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterThree.vue